import React, { useCallback, useMemo } from 'react';
import useSession from '#/common/hooks/useSession';
import useToast from '#/common/hooks/useToast';
import syncTisTenantDataMutation from '../../tenants/hooks/useSyncTisTenantDataMutation';
import { PageAction } from '#/app/providers/PageProvider';
import { PageActions } from '#/common/components/SubPage';

const DataImportPage: React.FC = () => {
  const { alert, confirm } = useToast();
  const { syncTisTenant } = syncTisTenantDataMutation();
  const session = useSession();

  const fetchTisData = useCallback(async () => {
    const sure = await confirm(
      'warning',
      `Are you sure you want to fetch the Trane Cloud data for ${session.tenantIDs?.length} tenants?`,
    );

    if (!sure) {
      return;
    }

    try {
      const tisIds =
        session.tenants?.map((t) => t.tenant.tisId).filter((tid): tid is string => !!tid) ?? [];

      const result = await syncTisTenant(tisIds);
      if (result?.errors) {
        throw result.errors;
      }

      void alert(
        'success',
        `Buildings, Assets and Asset properties synced! Findings and Exceptions are scheduled for sync and will be done in a few minutes.`,
      );
    } catch (e: any) {
      console.log('TIS Sync error', e);
      void alert('error', 'Oops, something unexpected happened!');
    }
  }, [confirm, alert, syncTisTenant]);

  const actions = useMemo<PageAction[]>(() => {
    return [
      {
        id: 'fetch-tis-assets',
        type: 'button',
        props: {
          label: 'Sync TC data',
          onClick: fetchTisData,
        },
      },
      {
        id: 'new-data-import',
        type: 'dropdown-button',
        props: {
          label: '+ New Data Import',
          items: [
            { key: 'import-assets', label: 'Assets Import', path: '/admin/data-import/assets' },
            {
              key: 'upload-workorders',
              label: 'Work Orders Import',
              path: '/admin/data-import/work-orders',
            },
            {
              key: 'upload-findings',
              label: 'Findings Import',
              path: '/admin/data-import/findings',
            },
            {
              key: 'upload-capital-needs',
              label: 'Capital Needs Import',
              path: '/admin/data-import/capital-needs',
            },
          ],
        },
      },
    ];
  }, [fetchTisData]);

  return (
    <>
      <PageActions actions={actions} />
      <div className="coming-soon">Data Import Table coming soon.</div>
    </>
  );
};

export default React.memo(DataImportPage);
